module.exports = __webpack_public_path__ + "img/retail09.a6bc65f1.png";